import { render, staticRenderFns } from "./AtomPinSimpleText.vue?vue&type=template&id=a1d2b638&"
import script from "./AtomPinSimpleText.vue?vue&type=script&lang=js&"
export * from "./AtomPinSimpleText.vue?vue&type=script&lang=js&"
import style0 from "./AtomPinSimpleText.vue?vue&type=style&index=0&id=a1d2b638&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomCustomButton: require('/app/components/atoms/common/AtomCustomButton.vue').default})
